export default __webpack_public_path__ + "static/media/TechStackimg.b075ffed.png";